import { useState, ReactElement, useEffect } from 'react';
import messages from '../locales/messages';
import 'src/common/style/common.scss';
import { ThanksModal, ThanksTableVerbiage } from 'src/common/utils/ThanksModal';
import { estMaintenanceTableData } from '../constants/default';
import { createUseTranslation } from '../../../common/hooks/widgets/useTranslation';
import { useMASSAASSelector } from '../lib/redux/hooks';

export interface thanksProps {
  usersAmount: number;
  envCount: number;
  concurrentAmount: number;
  authorizedAmount: number;
  healthScoresAmount: number;
  tileValue: string;
  licensePriceMonthly: string;
  packageName: string;
  bpName: string;
  onInspection: boolean;
  appPoints: number;
  tableText1: string;
  tableText2: string;
  tableText3: string;
  tableVal1: string;
  tableVal2: string;
  tableVal3: string;
  offering: string;
  aiService: string;
}

const Thanks = ({
  usersAmount,
  envCount,
  concurrentAmount,
  authorizedAmount,
  healthScoresAmount,
  tileValue,
  licensePriceMonthly,
  packageName,
  bpName,
  onInspection,
  appPoints,
  tableText1,
  tableText2,
  tableText3,
  tableVal1,
  tableVal2,
  tableVal3,
  offering,
  aiService,
}: thanksProps): ReactElement => {
  const [, setShowThanksModal] = useState(true);
  const AEMMessages = useMASSAASSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);
  const titleThanks: ThanksTableVerbiage[] = [
    { group: 'title', value: useTranslation('thank_you') },
    {
      group: 'subTitle',
      value: useTranslation('received_text'),
    },
  ];

  const widgetTitleThanks: ThanksTableVerbiage[] = [
    {
      group: 'widgetTitle1',
      value: useTranslation('req_detail'),
    },
  ];

  const essentialsMaintenanceInfo: ThanksTableVerbiage[] = [
    {
      group: useTranslation('package_label'),
      value: packageName,
    },
    {
      group: useTranslation('user_text'),
      value: String(usersAmount),
    },
    {
      group: useTranslation('env_text'),
      value: String(envCount),
    },
    {
      group: useTranslation('work_order_text'),
      value: String(estMaintenanceTableData.workOrdersHour),
    },
    {
      group: useTranslation('health_score_text'),
      value: String(estMaintenanceTableData.healthScoresrHour),
    },
    {
      group: 'AI Service',
      value: aiService,
    },
    {
      group: useTranslation('estimated_text'),
      value: String(licensePriceMonthly),
    },
  ];

  const essentialsInspectionInfo: ThanksTableVerbiage[] = [
    {
      group: useTranslation('package_label'),
      value: packageName,
    },
    {
      group: tableText1,
      value: tableVal1,
    },
    {
      group: tableText2,
      value: tableVal2,
    },
    {
      group: tableText3,
      value: tableVal3,
    },
    {
      group: useTranslation('estimated_text'),
      value: String(licensePriceMonthly),
    },
  ];

  const essentialsInfo =
    offering === 'Maintenance'
      ? essentialsMaintenanceInfo
      : essentialsInspectionInfo;

  const standardInfo: ThanksTableVerbiage[] = [
    {
      group: useTranslation('package_label'),
      value: packageName,
    },
    {
      group: useTranslation('concurrent_user'),
      value: String(concurrentAmount),
    },
    {
      group: useTranslation('authorized_user'),
      value: String(authorizedAmount),
    },
    {
      group: useTranslation('health_score_text'),
      value: String(healthScoresAmount),
    },
    {
      group: useTranslation('appPoints_text'),
      value: String(appPoints),
    },
    {
      group: useTranslation('estimated_text'),
      value: String(licensePriceMonthly),
    },
  ];

  const contentThanks =
    tileValue === 'essentials' ? essentialsInfo : standardInfo;

  bpName &&
    contentThanks.push({
      group: useTranslation('bp_title'),
      value: bpName,
    });

  const buttonThanks: ThanksTableVerbiage[] = [
    {
      group: 'button1',
      value: useTranslation('return_est_text'),
    },
  ];

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(true);
  }, [
    usersAmount,
    envCount,
    concurrentAmount,
    onInspection,
    authorizedAmount,
    healthScoresAmount,
    offering,
    tableVal1,
    tableVal2,
    tableVal3,
    aiService,
  ]);
  return (
    <ThanksModal
      showThanksModal={showModal}
      pageTitle="MAS SaaS Pricing Page"
      object="Pricing Page"
      productTitle={'MAS SaaS Price Estimator'}
      pageUrl={'/products/maximo/pricing/'}
      location={'Estimator'}
      titleThanks={titleThanks}
      widgetTitleThanks={widgetTitleThanks}
      contentThanks={contentThanks}
      buttonThanks={buttonThanks}
      setShowThanksModal={setShowThanksModal}
    />
  );
};

export default Thanks;
